"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const hooks_1 = require("@icr-ui/hooks");
const icons_1 = require("@icr-ui/icons");
const theme_1 = require("@icr-ui/theme");
const react_1 = require("react");
const styles_1 = require("./styles");
const Actions = (0, react_1.forwardRef)((props, _ref) => {
    const { content, label } = props;
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const innerRef = (0, hooks_1.useClickOutside)(() => setIsOpen(false));
    return ((0, jsx_runtime_1.jsxs)(styles_1.StyledActionsWrapper, { flexDirection: "row", gap: "8px", onClick: () => setIsOpen(!isOpen), ref: innerRef, ...{ isOpen }, "data-testid": "actions", children: [label ? ((0, jsx_runtime_1.jsx)(styles_1.StyledActionsLabel, { variant: "body", size: "small", weight: "medium", colorScheme: {
                    type: 'text',
                    color: 'secondary',
                }, children: label })) : null, (0, jsx_runtime_1.jsx)(icons_1.ThreeDotsHorizontalRoundedIcon, { color: isOpen ? theme_1.primary.light : theme_1.primary.main }), (0, jsx_runtime_1.jsx)(styles_1.StyledActionContent, { fullWidth: true, flexDirection: "column", noWrap: true, "data-testid": "action-content", children: content.map(({ onClick, label, colorVariant }, index) => {
                    const handleClick = () => {
                        onClick();
                        setIsOpen(false);
                    };
                    return ((0, jsx_runtime_1.jsx)(styles_1.StyledActionItem, { onClick: () => handleClick(), variant: "body", size: "normal", "data-testid": "action-item", colorVariant: colorVariant, children: label }, index));
                }) })] }));
});
Actions.displayName = 'Actions';
exports.default = Actions;
//# sourceMappingURL=actions.js.map